import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './collapsibleSearch.module.css';
import { langType, withLang } from '../../../i18n';

const CollapsibleSearch = ({
  children, translate: t
}) => {
  const [open, setOpen] = useState(true);

  return (
    <div className={styles.searchContainer}>
      <button
        type="button"
        className={`${styles.searchButton} button--action ${!open ? 'icon--search' : ''} theme-transparent`}
        title={t('manageSurveys.search.title')}
        onClick={() => setOpen((v) => !v)}
      >
        {open ? t('manageSurveys.search.hide') : ''}
      </button>

      <div className={`${styles.searchForm} ${open ? styles.visible : ''}`}>
        {children}
      </div>
    </div>
  );
};

CollapsibleSearch.propTypes = {
  children: PropTypes.node,
  ...langType
};

CollapsibleSearch.defaultProps = {
  children: null
};

export default withLang(CollapsibleSearch);
